// removed by extract-text-webpack-plugin
module.exports = {"meeting-container":"meetingAlert-module-meeting-container-d50fded8251a60e10941f7ad9a61b2fc--","meetingtitle":"meetingAlert-module-meetingtitle-d1ffb55ea6d13faeee93ea5e8ee9d950--","timer-content":"meetingAlert-module-timer-content-2a81b968fe7584c1b98f692effcfeb86--","meetingimage":"meetingAlert-module-meetingimage-7e4dfe420947d88a97377dc5f3e06006--","text":"meetingAlert-module-text-575fdfe10c83b98578c240b105e0ab66--","timer":"meetingAlert-module-timer-1653d6f5240862f3444920fc39affb86--"};


//////////////////
// WEBPACK FOOTER
// /src/components/meetingAlert/meetingAlert.module.scss
// module id = 1844
// module chunks = 0